import React, { useState, useContext, Fragment, useEffect } from "react";
import AuthContext from "../../../context/auth/authContext";
import "../../../styles/index.css";
const ChangePass = (props) => {
  const authContext = useContext(AuthContext);
  const { currentUser, changePassword, addError, loadUser } = authContext;
  const [pass, setPass] = useState({ password: "", password2: "" });
  const { password, password2 } = pass;
  const onChange = (e) => {
    setPass({ ...pass, [e.target.name]: e.target.value });
  };
  useEffect(() => {
    if (!currentUser) {
      props.history.push("/");
    }
    //eslint-disable-next-line
  }, []);
  const onSubmit = (e) => {
    e.preventDefault();
    if (password.length < 6) {
      addError("Passwords must be at least 6 charachters long");
    } else if (password !== password2) {
      addError("Passwords do not match");
    } else {
      changePassword(pass.password);
      props.history.push("/");
      loadUser();
    }
  };
  return (
    <Fragment>
      <h1 class='mb-4 upperfont'>Change Password</h1>
      <hr></hr>
      <div className='form-group row'>
        <label className='col-lg-3 col-form-label form-control-label fontcool'>
          Password
        </label>
        <div className='col-lg-9'>
          <input
            className='form-control simplefont'
            type='password'
            name='password'
            value={password}
            onChange={onChange}
          />
        </div>
      </div>
      <div className='form-group row'>
        <label className='col-lg-3 col-form-label form-control-label fontcool'>
          Confirm password
        </label>
        <div className='col-lg-9'>
          <input
            className='form-control simplefont'
            type='password'
            name='password2'
            value={password2}
            onChange={onChange}
          />
        </div>
      </div>
      <button onClick={onSubmit} className='btn btn-dark btn-block slantfont'>
        Change Password
      </button>
    </Fragment>
  );
};

export default ChangePass;
